'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var FlightGridsController = function FlightGridsController($scope, $timeout, reservationSystemService, reoptimizationService, $state, transitionSearchCriteriaService, dataRetrieverService, dataRetrieverConstantsService, $q, serviceFilterBuilderService, currentStateCriteriaService, classFilterBuilderService, scenarioService, calculateEffectiveValueService, momentService, $rootScope, flightSearchCriteriaFilterBuilderService, systemConstants, flightPostDepartureDataService, $log, navigationHistoryService, userSecureService, flightLiveDataService, gridRecordsNavigationService, toolbarNextPreviousButtonService, flightDataAdjustmentService, flightAdjustmentValidationService, reoptPreviewDataUtilsService, userPreferencesService, configurationService, flightModeService, gridMaximizeConstants) {
  $scope.isDAOnlyMode = flightModeService.isDAOnlyMode();
  var ovbkgPrivilege = userSecureService.hasAuthorization('overbooking-initialization', 'write');
  var POST_DEPARTURE_SUFFIX = '-post-departure';
  var cabinDataRetriever = $scope.isDAOnlyMode ? dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.CABIN_DA_MODE) : dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.CABIN_MODE);
  var cabinDeepDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.CABIN_DEEP_MODE);
  var serviceDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.SERVICE_MODE);
  var servicePostDepartureDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.SERVICE_POST_DEPARTURE_MODE);
  var bookingMatrixRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.BOOKING_MATRIX_MODE);
  var classDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.CLASS_MODE);
  var classPostDepartureDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.CLASS_POST_DEPARTURE_MODE);
  var segmentPostDepartureDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FLIGHT_SCREEN, dataRetrieverConstantsService.SEGMENT_CLASS_POST_DEPARTURE_MODE);

  //service data retriever wil not invoke for data until flight and day is not selected
  serviceDataRetriever.setCustomSearchCriteriaRules($q.reject());
  bookingMatrixRetriever.setCustomSearchCriteriaRules($q.reject());
  $scope.selectedRows = {
    "class": [],
    cabin: [],
    segment: [],
    service: []
  };
  $scope.selectionFilters = {};
  $scope.cabinNotSelectedRows = [];
  $scope.cabinCogOptions = require('../config/cogOptions.json').cabin;
  $scope.classCogOptions = require('../config/cogOptions.json')["class"];
  $scope.serviceCogOptions = require('../config/cogOptions.json').service;
  $scope.serviceBookingMatrixCogOptions = require('../config/cogOptions').serviceBookingMatrix;
  $scope.cabinFlightAnalysisPostDepartureContextMenuItems = [{
    caption: 'Overbkg Initialization',
    event: 'context-menu:cabin-flight-analysis-market-analysis-post-departure',
    disabled: !ovbkgPrivilege
  }];
  if (!$scope.isDAOnlyMode) {
    $scope.cabinFlightAnalysisContextMenuItems = [{
      caption: 'Market Analysis',
      event: 'context-menu:cabin-flight-analysis-market-analysis'
    }];
  }
  $scope.serviceFlightAnalysisContextMenuItems = [{
    caption: 'Market Analysis',
    event: 'context-menu:service-flight-analysis-market-analysis'
  }];
  $scope.bookingMatrixMode = 'bookingsIncremental';
  $scope.enableBookingMatrix = true;
  $scope.showBookingMatrix = false;
  $scope.bookingMatrixInitialized = false;
  $scope.toggleBookingMatrix = function () {
    if (!$scope.showBookingMatrix && !$scope.bookingMatrixInitialized) {
      $scope.$broadcast('grid:loadData:service-demand-analysis-booking-matrix');
      $scope.bookingMatrixInitialized = true;
    }
    $scope.showBookingMatrix = !$scope.showBookingMatrix;
  };
  var gridIdToVisibleGridName = {
    cabinGridIdName: 'cabin',
    'class-flight-analysis': 'class',
    'segment-flight-analysis': 'segment',
    'service-flight-analysis': 'service',
    'service-flight-analysis-booking-matrix': 'booking-matrix'
  };
  var cabinGridId = $scope.isDAOnlyMode ? 'cabin-flight-da-analysis' : 'cabin-flight-analysis';
  gridIdToVisibleGridName[cabinGridId] = 'cabin';
  var gridNameToGridId = _.invert(gridIdToVisibleGridName);
  var visibleGrid = 'cabin';
  $scope.isClassOpened = false;
  $scope.isServiceOpened = false;
  $scope.isSegmentOpened = false;
  $scope.isPostDeparture = currentStateCriteriaService.isPostDeparture();
  function gridNameToId(gridName) {
    var gridId = gridNameToGridId[gridName];
    if ($scope.isPostDeparture) {
      gridId += POST_DEPARTURE_SUFFIX;
    }
    return gridId;
  }
  $scope.isCabinSelected = function () {
    return $scope.selectedRows.cabin.length > 0;
  };
  function toLegDateKey(obj) {
    return obj.leg + obj.legDepartureDateMoment.startOf('day').toISOString();
  }
  $scope.isServiceSelected = function () {
    var legs = _.chain($scope.selectedRows.cabin).map(toLegDateKey).uniq().value();

    // only one day and one leg are supported
    return legs.length === 1;
  };
  function setBackFunctionInNavigationHistoryService() {
    var gridToFunction = {
      'cabin': $scope.showCabin,
      'class': $scope.showClass,
      'segment': $scope.showSegmentClass,
      'service': $scope.showService
    };
    navigationHistoryService.setPreviousMode(visibleGrid, gridToFunction[visibleGrid]);
  }

  // when changing a tab we loose the selection of any grid other than the cabin one
  function resetSelection() {
    $scope.selectedRows["class"] = [];
    $scope.selectedRows.segment = [];
    $scope.selectedRows.service = [];
  }
  function tabChangeCommon() {
    resetSelection();
    $rootScope.$broadcast('flight-analysis:flight-grids-selection-changed', $scope.selectedRows);
    setBackFunctionInNavigationHistoryService();
  }
  $scope.showService = function () {
    $scope.retainTheViewInTabSwitch('isFlightServiceAnalysisPostDepartureGridExpanded', 'isFlightServiceAnalysisGridExpanded');
    if ($scope.isServiceSelected() || $scope.visibilityManager.isServiceGridEnable()) {
      tabChangeCommon();
      $scope.isServiceOpened = true;
      flightLiveDataService.setCabinSelectedRows($scope.selectedRows.cabin);
      setServiceSearchRule().then(function () {
        $scope.toggleGrid('service');
      });
    }
  };
  $scope.retainTheViewInTabSwitch = function (flagPostDep, flag) {
    $scope.screenState.isFlightAnalysisGridExpanded = $scope.isPostDeparture ? $scope.screenState[flagPostDep] : $scope.screenState[flag];
  };
  $scope.showCabin = function () {
    $scope.retainTheViewInTabSwitch('isFlightCabinPostDepartureAnalysisGridExpanded', 'isFlightCabinAnalysisGridExpanded');
    tabChangeCommon();
    $scope.toggleGrid('cabin');
    if ($scope.reoptPreviewData && ($scope.reoptPreviewData.ndReopt || $scope.reoptPreviewData.mdReopt)) {
      $rootScope.$broadcast('re-opt:reset:cabin-flight-analysis');
    }
  };
  $scope.showClass = function () {
    $scope.retainTheViewInTabSwitch('isFlightClassPostDepartureAnalysisGridExpanded', 'isFlightClassAnalysisGridExpanded');
    tabChangeCommon();
    $scope.toggleGrid('class');
    $scope.isClassOpened = true;
    if ($scope.isCabinSelected()) {
      $scope.filterClassWithCabinData();
    }
  };
  $scope.showSegmentClass = function () {
    $scope.screenState.isFlightAnalysisGridExpanded = $scope.screenState.isFlightSegmentPostDepartureAnalysisGridExpanded;
    tabChangeCommon();
    $scope.toggleGrid('segment');
    $scope.isSegmentOpened = true;
    if ($scope.isCabinSelected()) {
      $scope.filterSegmentWithCabinData();
    }
  };
  $scope.filterClassWithCabinData = function () {
    if ($scope.isPostDeparture) {
      return filterTabWithCabinData(classPostDepartureDataRetriever, 'class');
    } else {
      return filterTabWithCabinData(classDataRetriever, 'class');
    }
  };
  $scope.filterSegmentWithCabinData = function () {
    if ($scope.isPostDeparture) {
      return filterTabWithCabinData(segmentPostDepartureDataRetriever, 'segment');
    }
  };
  function filterTabWithCabinData(dataRetriever, gridName) {
    var searchRules = cabinDataRetriever.getSearchCriteriaRules();
    return $q.when(searchRules).then(function () {
      var searchCriteriaDefer = $q.defer();
      dataRetriever.setCustomSearchCriteriaRules(searchCriteriaDefer.promise);
      if ($scope.isCabinSelected()) {
        searchCriteriaDefer.resolve(classFilterBuilderService.buildFilter($scope.selectedRows.cabin, $scope.cabinNotSelectedRows, $scope.isPostDeparture));
        $scope.$broadcast('grid:loadData:' + gridNameToId(gridName));
      } else {
        searchCriteriaDefer.reject();
      }
    });
  }
  $scope.toggleGrid = function (newVisibleGrid) {
    $rootScope.$broadcast('workflow-tab-changed', newVisibleGrid);
    $rootScope.$broadcast('grid:checkDeferredClear:' + gridNameToId(newVisibleGrid));
    visibleGrid = newVisibleGrid;
    setVisibleGridInScenarioService();
  };
  $scope.isVisibleGrid = function (gridName) {
    return visibleGrid === gridName;
  };
  $scope.onSearchChangeEvent = function () {
    visibleGrid = 'cabin';
    $scope.isClassOpened = false;
    $scope.isServiceOpened = false;
    $scope.isSegmentOpened = false;
    $scope.isPostDeparture = currentStateCriteriaService.isPostDeparture();
    reoptimizationService.resetReoptPreviewMode($scope.reoptPreviewData);
    $timeout(function () {
      $scope.$broadcast('brush-filter:filterApplied');
    }, 0);
  };
  $scope.getSelectedGrid = function () {
    return visibleGrid;
  };
  $scope.reloadCurrentGrid = function () {
    $rootScope.$broadcast('grid:clearAndLoadData:' + gridNameToId($scope.getSelectedGrid()));
  };
  $scope.$on('re-opt:publish-finished', $scope.reloadCurrentGrid);
  $scope.$on('re-opt:undo-finished', function () {
    if (visibleGrid !== 'cabin') {
      $rootScope.$broadcast('grid:setDeferredClear:cabin-flight-analysis');
    }
    $scope.reloadCurrentGrid();
  });
  function getSendArguments(visibleGrid, selectedRows) {
    return selectedRows[visibleGrid];
  }
  function afterSendCallback(targetGridId, visibleGrid) {
    $rootScope.$broadcast('clearChangedValue');
    if (visibleGrid === 'class') {
      $rootScope.$broadcast('grid:setDeferredClear:cabin-flight-analysis');
    }
    var nextFlightJumpEnabled = userPreferencesService.getUserSettingComponent('nextFlightAfterSend');
    if (nextFlightJumpEnabled) {
      $rootScope.$broadcast('grid:moveToNextKey:' + targetGridId, true);
    } else {
      $rootScope.$broadcast('grid:clearAndLoadData:' + visibleGrid + '-flight-analysis');
    }
  }
  $scope.$on('grid:clearAndSelect:finished', function () {
    $rootScope.$broadcast('grid:clearAndLoadData:' + visibleGrid + '-flight-analysis');
  });
  function sendGridHandler(evt, targetGridId) {
    if (_.includes(['inventory-management', 'overbooking-management'], targetGridId)) {
      return;
    }
    reoptimizationService.resetReoptPreviewMode($scope.reoptPreviewData);
    reservationSystemService.send(getSendArguments(visibleGrid, $scope.selectedRows)).then(function () {
      afterSendCallback(targetGridId, visibleGrid);
    });
  }
  $scope.$on('sendGrid', sendGridHandler);
  $scope.$on('reoptimizeServiceGrid', function () {
    reoptimizationService.reoptimizeFromMarketScreen($scope.selectedRows[visibleGrid], $scope.scenarioName);
  });
  $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChangeEvent);
  $scope.$on('reoptimizeGrid', function (evt, gridId) {
    if (_.includes(['inventory-management', 'overbooking-management'], gridId)) {
      return;
    }
    reoptimizationService.reoptimizeFromFlightScreen($scope.selectedRows[visibleGrid], $scope.scenarioName);
  });
  $scope.$on('scenarios:saved', function (evt, gridId) {
    reoptimizationService.resetReoptPreviewMode($scope.reoptPreviewData);
    $scope.$broadcast('overrides:clear-cells', gridId);
  });
  var setSelectedRows = function setSelectedRows(grid, selectedRows) {
    $scope.selectedRows[grid] = selectedRows;
  };
  function onRowSelection(selectedRows, gridId, allRows, selectedRowsIndexes, selectionFilters, visibleRowProperties) {
    $scope.selectionFilters[gridId] = selectionFilters;
    if (gridId.indexOf(POST_DEPARTURE_SUFFIX) !== -1) {
      gridId = gridId.replace(POST_DEPARTURE_SUFFIX, '');
    }
    var grid = gridIdToVisibleGridName[gridId];
    setSelectedRows(grid, selectedRows);
    if (grid === 'cabin') {
      var cabinGridKey = toolbarNextPreviousButtonService.getRowKeyId(gridId);
      $scope.cabinNotSelectedRows = allRows && _.difference(allRows, selectedRows);
      $scope.selectedRowIndexes = selectedRowsIndexes;
      $scope.cabinAllRows = allRows;
      if (visibleRowProperties) {
        gridRecordsNavigationService.setParentGridInformation(visibleRowProperties.displayRows, visibleRowProperties.displayRowIndexes, cabinGridKey, visibleRowProperties.displayRowFilters, visibleRowProperties.allRowFilters);
      }
      if (visibleGrid === 'class') {
        $scope.showClass();
      }
      if (visibleGrid === 'segment') {
        $scope.showSegmentClass();
      }
      if (visibleGrid === 'service') {
        $scope.showService();
      }
    }
    gridRecordsNavigationService.setDemandManagementGridDisplayed(false);
    $rootScope.$broadcast('flight-analysis:flight-grids-selection-changed', $scope.selectedRows);
  }
  $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowsIndexes, selectionFilters, visibleRowProperties) {
    onRowSelection(selectedRows, gridId, allRows, selectedRowsIndexes, selectionFilters, visibleRowProperties);
  });

  //restore grid selections when changing scenario
  $scope.$on($scope.screen + ':scenariosChanged', function () {
    reoptimizationService.resetReoptPreviewMode($scope.reoptPreviewData);
    $scope.cachedSelectionFilters = _.clone($scope.selectionFilters);
  });
  $scope.$on('grid:afterUpdateBoundData', function (event, data, gridId) {
    if ($scope.cachedSelectionFilters && $scope.cachedSelectionFilters[gridId]) {
      $scope.$broadcast('grid:clearAndSelect:' + gridId, $scope.cachedSelectionFilters[gridId]);
      delete $scope.cachedSelectionFilters[gridId];
    }
    gridRecordsNavigationService.setDemandManagementGridDisplayed(false);
  });
  $scope.onBrushFilterApplied = function (event, brushFilter) {
    if (brushFilter && brushFilter.filterType && ['dateRange', 'legs', 'cabin', 'dow', 'season', 'flightLevel'].indexOf(brushFilter.filterType) > -1) {
      if (visibleGrid !== 'cabin') {
        visibleGrid = 'cabin';
        $scope.screenState.isFlightAnalysisGridExpanded = $scope.screenState.isFlightCabinAnalysisGridExpanded;
      }
    }
    if (reoptPreviewDataUtilsService.isMdReopt($scope.reoptPreviewData) || reoptPreviewDataUtilsService.isNdReopt($scope.reoptPreviewData)) {
      reoptimizationService.resetReoptPreviewMode($scope.reoptPreviewData);
    }
  };
  function setServiceSearchRule() {
    var searchCriteriaDefer1 = $q.defer();
    var searchCriteriaDefer2 = $q.defer();
    if ($scope.isPostDeparture) {
      servicePostDepartureDataRetriever.setCustomSearchCriteriaRules(searchCriteriaDefer1.promise);
    } else {
      serviceDataRetriever.setCustomSearchCriteriaRules(searchCriteriaDefer1.promise);
    }
    bookingMatrixRetriever.setCustomSearchCriteriaRules(searchCriteriaDefer2.promise);
    var rules;
    if ($scope.isServiceSelected()) {
      rules = flightSearchCriteriaFilterBuilderService.buildFilter($scope.selectedRows.cabin);
    } else {
      rules = flightSearchCriteriaFilterBuilderService.buildFilter();
    }
    return cabinDeepDataRetriever.setCustomSearchCriteriaRules(rules).localSortApplied().retrieveComponentData('service-flight-analysis').then(function (data) {
      var serviceIdsSearchCriteriaRule = serviceFilterBuilderService.buildFilter(data);
      searchCriteriaDefer1.resolve(serviceIdsSearchCriteriaRule);
      searchCriteriaDefer2.resolve(serviceIdsSearchCriteriaRule);
      reoptPreviewDataUtilsService.setServiceIdsSearchCriteriaRule($scope.reoptPreviewData, serviceIdsSearchCriteriaRule);
      $scope.$broadcast('grid:loadData:' + gridNameToId('service'));
      $scope.$broadcast('grid:loadData:' + gridNameToId('booking-matrix'));
    });
  }
  $scope.$on('brush-filter:filterApplied', $scope.onBrushFilterApplied);
  $scope.$on('context-menu:cabin-flight-analysis-market-analysis', function () {
    var searchCriteria = transitionSearchCriteriaService.flightAnalysisGridToMarketAnalysis($scope.selectedRows.cabin, 'leg', 'flightDepartureDateMoment');
    $state.go('app.market-analysis', {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: searchCriteria
      }
    });
  });
  $scope.$on('save-change:post-departure-data-screen', function (event, selectedRows) {
    flightPostDepartureDataService.updateIgnorePostDepartureStatus(selectedRows).then(onRequestSuccess, onRequestFail);
  });
  function onRequestSuccess() {
    $rootScope.$broadcast('clearChangedValue');
    $scope.$broadcast('post-departure-ignore: success');
    toastr.success('Your overrides have been successfully submitted.');
  }
  function onRequestFail() {
    $log.error('FlightGridsController: onRequestFail - An error has occurred');
    toastr.error('An error has occurred. Please try again.');
  }
  $scope.$on('context-menu:cabin-flight-analysis-market-analysis-post-departure', function () {
    var selectedRows = $scope.selectedRows.cabin;
    var rowsFromPostDepartureToOverbooking = _.transform(selectedRows, function (result, row) {
      var splittedOriginDestination = _.split(row.leg, '-');
      return result.push({
        origin: splittedOriginDestination[0],
        destination: splittedOriginDestination[1],
        cabin: row.cabinCode,
        endDate: momentService.now(momentService.FIELD.DEPARTURE_DATE),
        startDate: momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(365, 'days')
      });
    });
    $state.go('app.system-status', {
      transitionData: {
        skipSearch: true,
        'system-status:force-tab': {
          tabId: systemConstants.SCREEN_VALUE.SYSTEM_STATUS.OVERBOOKING
        },
        'reinit-overbooking:force-add-row': {
          rows: rowsFromPostDepartureToOverbooking
        }
      }
    });
  });
  $scope.$on('context-menu:service-flight-analysis-market-analysis', function () {
    var searchCriteria = transitionSearchCriteriaService.flightAnalysisGridToMarketAnalysis($scope.selectedRows.service, 'market', 'departureDateMoment');
    $state.go('app.market-analysis', {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: searchCriteria
      }
    });
  });
  function findAffectedLegsOrServices(gridData, rowData) {
    return _.filter(gridData, function (item, index) {
      if (_.isMatch(item, {
        legId: rowData.legId
      })) {
        item.originalRowId = index;
        return true;
      }
      if (_.isMatch(item, {
        serviceId: rowData.serviceId
      })) {
        item.originalRowId = index;
        return true;
      }
    });
  }
  function setManualCtrlIndicator(gridData, rowData, colName, ctrlIndicatorValue) {
    var affectedRows = findAffectedLegsOrServices(gridData, rowData);
    return _.chain(affectedRows).map(function (row) {
      return _.findIndex(gridData, {
        originalRowId: row.originalRowId
      });
    }).filter(function (value) {
      return value !== -1;
    }).forEach(function (rowId) {
      gridData[rowId][colName] = ctrlIndicatorValue;
    }).value();
  }
  $scope.onCellEditHandler = function (gridData, rowId, colName) {
    var isDemandDistributionIncremental = configurationService.isDemandDistributionIncremental();
    var affectedFields = [];
    var affectedRowIds = [];
    var rowData = gridData[rowId];
    var gridId = gridNameToId(visibleGrid);
    var calculatedVal = calculateEffectiveValueService.getCalculatedField(rowData, colName, gridId);
    if (!isDemandDistributionIncremental) {
      var effectiveVal = calculateEffectiveValueService.getField(rowData, colName, gridId);
      if (effectiveVal) {
        rowData[effectiveVal.fieldName] = effectiveVal.value;
        affectedFields.push(effectiveVal.fieldName);
      }
    }
    if (colName === 'isManuallyControlled') {
      var ctrlIndicatorValue = gridData[rowId][colName];
      affectedRowIds = setManualCtrlIndicator(gridData, rowData, colName, ctrlIndicatorValue);
    }
    if (calculatedVal) {
      rowData[calculatedVal.fieldName] = calculatedVal.value;
      affectedFields.push(calculatedVal.fieldName);
    }
    return {
      ids: _.isEmpty(affectedRowIds) ? [rowId] : affectedRowIds,
      fieldNames: _.isEmpty(affectedFields) ? [colName] : affectedFields
    };
  };
  $scope.$on('cog:grid-service-booking-matrix', function (event, cogValue) {
    $scope.bookingMatrixMode = cogValue.val[0];
    $scope.updateBookingMatrixMode();
    $rootScope.$broadcast('grid:loadData:service-flight-analysis-booking-matrix');
  });
  $scope.activeView = function (view) {
    return $scope.gridView === view;
  };
  $scope.customSaveValidation = function (rows) {
    return flightAdjustmentValidationService.validateRows(rows);
  };
  $scope.customSaveDataAdjuster = function (rows) {
    return flightDataAdjustmentService.adjustData(rows);
  };
  $scope.updateBookingMatrixMode = function () {
    bookingMatrixRetriever.updateAdditionalParameters({
      bookingMatrixMode: $scope.bookingMatrixMode
    });
  };
  $scope.updateBookingMatrixMode();
  $scope.$on('grid:manual-refresh:class-flight-analysis', function () {
    $rootScope.$broadcast('grid:setDeferredClear:cabin-flight-analysis');
  });
  $scope.initializeGridMaximizeFlags = function (gridId) {
    var maximizeFlag = gridMaximizeConstants.GRID_KEY_TO_MAXIMIZE_FLAG_MAPPING[gridId];
    if (!_.isUndefined(maximizeFlag)) {
      var workflowMapping = gridMaximizeConstants.GRID_KEY_TO_WORKFLOW_SETTING_MAPPING[gridId];
      var workFlowSettingsValue;
      if (gridId.indexOf('flight-analysis-post-departure') !== -1) {
        workFlowSettingsValue = _.isUndefined(userPreferencesService.getUserSettingComponentByScreenName(workflowMapping, 'flightAnalysisPostDeparture')) ? false : userPreferencesService.getUserSettingComponentByScreenName(workflowMapping, 'flightAnalysisPostDeparture');
      } else {
        workFlowSettingsValue = _.isUndefined(userPreferencesService.getUserSettingComponent(workflowMapping)) ? false : userPreferencesService.getUserSettingComponent(workflowMapping);
      }
      $scope.screenState[maximizeFlag] = _.isUndefined($scope.screenState[maximizeFlag]) ? workFlowSettingsValue : false;
    }
  };
  $scope.initializeGridMaximizeFlags('cabin-flight-analysis');
  $scope.initializeGridMaximizeFlags('class-flight-analysis');
  $scope.initializeGridMaximizeFlags('service-flight-analysis');
  $scope.initializeGridMaximizeFlags('cabin-flight-analysis-post-departure');
  $scope.initializeGridMaximizeFlags('class-flight-analysis-post-departure');
  $scope.initializeGridMaximizeFlags('segment-flight-analysis-post-departure');
  $scope.initializeGridMaximizeFlags('service-flight-analysis-post-departure');
  $scope.$on('gridExpand:flight-analysis', function (event, gridId) {
    var maximizeFlag = gridMaximizeConstants.GRID_KEY_TO_MAXIMIZE_FLAG_MAPPING[gridId];
    if (!_.isUndefined(maximizeFlag)) {
      $scope.screenState[maximizeFlag] = !$scope.screenState[maximizeFlag];
      $scope.screenState.isFlightAnalysisGridExpanded = $scope.screenState[maximizeFlag];
    }
  });
  function prepareDefferedGridsReload() {
    if (visibleGrid === 'class' || visibleGrid === 'service') {
      $rootScope.$broadcast('grid:setDeferredClear:cabin-flight-analysis');
    }
    if (visibleGrid === 'cabin' || visibleGrid === 'service') {
      $rootScope.$broadcast('grid:setDeferredClear:class-flight-analysis');
    }
  }
  function reloadVisibleGrid() {
    if (visibleGrid === 'class' || visibleGrid === 'cabin') {
      $scope.reloadCurrentGrid();
    }
  }
  $scope.$watch('screenState.flightAnalysisMode.visible', function (newValue, oldValue) {
    if (newValue === true && oldValue === false && $scope.screenState.flightManagementMode.overrides) {
      prepareDefferedGridsReload();
      reloadVisibleGrid();
    }
  });
  function switchToFlight(direction, emitAfterMoving) {
    var selectedRowData = direction === 'Next' ? gridRecordsNavigationService.getParentNextKeyRows() : gridRecordsNavigationService.getParentPreviousKeyRows();
    if (selectedRowData) {
      var flightGridKey = toolbarNextPreviousButtonService.getRowKeyId(gridNameToId('cabin'));
      selectedRowData = _.map(selectedRowData, function (data) {
        return _.pick(data, flightGridKey);
      });
      $scope.$broadcast('grid:clearAndSelect:' + gridNameToId('cabin'), selectedRowData);
    } else {
      if (emitAfterMoving) {
        $scope.$emit('grid:clearAndSelect:finished');
      }
    }
  }
  $scope.$on('grid:selectPreviousKey', function () {
    switchToFlight('Previous');
  });
  $scope.$on('grid:selectNextKey', function (event, gridId, emitAfterMoving) {
    switchToFlight('Next', emitAfterMoving);
  });
  function setVisibleGridInScenarioService() {
    _.forEach(gridIdToVisibleGridName, function (tab, gridName) {
      if ($scope.isVisibleGrid(tab)) {
        $scope.reoptPreviewData.visibleFlightGrid = gridName;
      }
    });
  }
  setVisibleGridInScenarioService();
};
FlightGridsController.$inject = ['$scope', '$timeout', 'ReservationSystemService', 'ReoptimizationService', '$state', 'TransitionSearchCriteriaService', 'DataRetrieverService', 'DataRetrieverConstantsService', '$q', 'ServiceFilterBuilderService', 'CurrentStateCriteriaService', 'classFilterBuilderService', 'ScenarioService', 'CalculateEffectiveValueService', 'MomentService', '$rootScope', 'FlightSearchCriteriaFilterBuilderService', 'SystemConstants', 'flightPostDepartureDataService', '$log', 'NavigationHistoryService', 'UserSecureService', 'FlightLiveDataService', 'GridRecordsNavigationService', 'ToolbarNextPreviousButtonService', 'FlightDataAdjustmentService', 'FlightAdjustmentValidationService', 'ReoptPreviewDataUtilsService', 'UserPreferencesService', 'ConfigurationService', 'FlightModeService', 'GridMaximizeConstants'];
module.exports = FlightGridsController;